
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const deleteSalesTargetApi = createAsyncThunk(
  "deleteSalesTarget",
  async ({
    rowId
}) => {
      console.log("rowId: in delete slice ", rowId);
    const response = await axiosInstance.delete(`/salesTarget/delete/${rowId}`);
    return response.data;
  }
);

const deleteSalesTargetSlice = createSlice({
  name: "deleteSalesTarget",
initialState: {
    deleteSalesTarget: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteSalesTargetApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSalesTargetApi.fulfilled, (state, action) => {
        state.deleteSalesTarget = action.payload;
        state.loading = false;
      })
      .addCase(deleteSalesTargetApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default deleteSalesTargetSlice.reducer;
